<template>
    <v-container full>
        <v-card class="ml-4 mt-10" max-width="400">
            <v-card-text>
                <div class="text-h6 mb-2">TruValidate Demo</div>
                <div class="text-body-2 text--secondary">
                    Version: <span class="font-weight-bold">{{ version }}</span>
                </div>
            </v-card-text>
        </v-card>
    </v-container>
</template>
<script>
export default {
    data() {
        return {
            version: __APP_VERSION__,
            buildDate: __BUILD_DATE__
        }
    }
}
</script>